import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_plus",
  "use": "icon-icon_plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_plus\"><defs><style></style></defs><path d=\"M906.24 496.64h-384v-384a25.6 25.6 0 0 0-51.2 0v384h-384a25.6 25.6 0 0 0 0 51.2h384v384a25.6 25.6 0 0 0 51.2 0v-384h384a25.6 25.6 0 0 0 0-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol